import _createForOfIteratorHelper from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _toConsumableArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _styled from "styled-components";
import React, { useMemo } from "react";
import difference from "lodash/difference";
import format from "date-fns/format";
import isSameDay from "date-fns/isSameDay";
import alarmMessages from "@smartheat/common/alarmMessages.json";
import { useAlarmRawEventsQuery } from "../../DeviceData/useAlarmRawEventsQuery";
import { useAlarmJournalQuery } from "../../DeviceData/useAlarmJournalQuery";
import { useAlarmsSubscription } from "../../DeviceData/useAlarmsSubscription";

var Container = _styled.div.withConfig({
  displayName: "ErrorsScreen__Container",
  componentId: "xqr8ee-0"
})(["flex:1;display:flex;flex-direction:column;height:0;"]);

var Description = _styled.div.withConfig({
  displayName: "ErrorsScreen__Description",
  componentId: "xqr8ee-1"
})(["text-align:center;margin-top:60px;font-size:24px;"]);

var ButtonsContainer = _styled.div.withConfig({
  displayName: "ErrorsScreen__ButtonsContainer",
  componentId: "xqr8ee-2"
})(["margin-top:60px;text-align:center;"]);

var ListContainer = _styled.div.withConfig({
  displayName: "ErrorsScreen__ListContainer",
  componentId: "xqr8ee-3"
})(["margin-top:40px;overflow-y:auto;background:linear-gradient(white 30%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),white 70%) 0 100%,radial-gradient(50% 0,farthest-side,rgba(0,0,0,0.2),rgba(0,0,0,0)),radial-gradient(50% 100%,farthest-side,rgba(0,0,0,0.2),rgba(0,0,0,0)) 0 100%;background:linear-gradient(white 30%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),white 70%) 0 100%,radial-gradient(farthest-side at 50% 0,rgba(0,0,0,0.2),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,rgba(0,0,0,0.2),rgba(0,0,0,0)) 0 100%;background-repeat:no-repeat;background-color:white;background-size:100% 40px,100% 40px,100% 14px,100% 14px;background-attachment:local,local,scroll,scroll;"]);

var DateRow = _styled.div.withConfig({
  displayName: "ErrorsScreen__DateRow",
  componentId: "xqr8ee-4"
})(["padding-bottom:10px;"]);

var DateTitle = _styled.div.withConfig({
  displayName: "ErrorsScreen__DateTitle",
  componentId: "xqr8ee-5"
})(["font-size:20px;padding:0 20px;"]);

var AlarmRow = _styled.div.withConfig({
  displayName: "ErrorsScreen__AlarmRow",
  componentId: "xqr8ee-6"
})(["padding:0 36px 10px;"]);

var StartDateCol = _styled.div.withConfig({
  displayName: "ErrorsScreen__StartDateCol",
  componentId: "xqr8ee-7"
})(["flex:0 0 auto;font-size:24px;margin-right:20px;min-width:65px;"]);

var AlarmCode = _styled.span.withConfig({
  displayName: "ErrorsScreen__AlarmCode",
  componentId: "xqr8ee-8"
})(["flex:0 0 auto;font-size:24px;margin-right:10px;font-weight:", ";min-width:45px;"], function (p) {
  return p.active ? "bold" : "inherit";
});

var AlarmTitle = _styled.div.withConfig({
  displayName: "ErrorsScreen__AlarmTitle",
  componentId: "xqr8ee-9"
})([""]);

var RestartMsg = _styled.div.withConfig({
  displayName: "ErrorsScreen__RestartMsg",
  componentId: "xqr8ee-10"
})(["font-color:#666666;"]);

var EventBriefRow = _styled.div.withConfig({
  displayName: "ErrorsScreen__EventBriefRow",
  componentId: "xqr8ee-11"
})(["display:flex;align-items:center;color:", ";"], function (p) {
  return p.system ? "#a9aaab" : "inherit";
});

var EventDetails = _styled.div.withConfig({
  displayName: "ErrorsScreen__EventDetails",
  componentId: "xqr8ee-12"
})([""]);

var StatusMsg = _styled.div.withConfig({
  displayName: "ErrorsScreen__StatusMsg",
  componentId: "xqr8ee-13"
})(["text-align:center;"]);

export function ErrorsScreen() {
  var journalQuery = useAlarmJournalQuery({
    fetchPolicy: "cache-and-network"
  });
  var journalQueryFailed = !journalQuery.loading && !!journalQuery.error;
  var rawEventsQuery = useAlarmRawEventsQuery({
    fetchPolicy: "cache-and-network",
    skip: !journalQueryFailed
  });
  var alarms = journalQueryFailed ? rawEventsQuery.data && rawEventsQuery.data.alarms : journalQuery.data && journalQuery.data.alarms;
  var alarmJournal = journalQuery.data && journalQuery.data.alarmJournal;
  var alarmRawEvents = rawEventsQuery.data && rawEventsQuery.data.alarmRawEvents;
  var grouppedEvents = useMemo(function () {
    return journalQueryFailed ? transformRawEvents(alarmRawEvents, alarms) : transformJournal(alarmJournal, alarms);
  }, [journalQueryFailed, alarmJournal, alarmRawEvents, alarms]);
  var loading = journalQuery.loading || rawEventsQuery.loading;
  useAlarmsSubscription({
    onSubscriptionData: function onSubscriptionData() {
      if (journalQueryFailed) {
        rawEventsQuery.refetch();
      } else {
        journalQuery.refetch();
      }
    }
  });
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Description, null, "\u0410\u0432\u0430\u0440\u0438\u0438", alarms && alarms.length > 0 && " (".concat(alarms.length, ")")), /*#__PURE__*/React.createElement(ListContainer, null, function () {
    if (loading) {
      return /*#__PURE__*/React.createElement(StatusMsg, null, "...\u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0430...");
    }

    if (grouppedEvents.length === 0) {
      return /*#__PURE__*/React.createElement(StatusMsg, null, "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445 \u043E\u0431 \u0430\u0432\u0430\u0440\u0438\u044F\u0445");
    }

    return grouppedEvents.map(function (g) {
      return /*#__PURE__*/React.createElement(DateRow, {
        key: g.dateStamp
      }, /*#__PURE__*/React.createElement(DateTitle, null, format(g.date, "d MMM yyyy")), g.events.map(function (e) {
        return /*#__PURE__*/React.createElement(AlarmRow, {
          key: e.id
        }, /*#__PURE__*/React.createElement(EventBriefRow, {
          active: e.active,
          system: e.init
        }, /*#__PURE__*/React.createElement(StartDateCol, null, format(e.eventAt, "HH:mm")), e.init ? /*#__PURE__*/React.createElement("em", null, "---\u041F\u0435\u0440\u0435\u0437\u0430\u043F\u0443\u0441\u043A \u0441\u0438\u0441\u0442\u0435\u043C\u044B---") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AlarmCode, {
          active: e.active
        }, e.alarmId), /*#__PURE__*/React.createElement(AlarmTitle, null, alarmMessages[e.alarmId] || "Неизвестная ошибка"))), !e.init && !e.active && /*#__PURE__*/React.createElement(EventDetails, null, "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E:", " ", e.finishedAt ? format(e.finishedAt, isSameDay(g.date, e.finishedAt) ? "HH:mm:ss" : "dd.MM.yyyy HH:mm:ss") : /*#__PURE__*/React.createElement("em", null, "\u043D\u0435\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043E")));
      }));
    });
  }()));
}

function getEventsGroup(grouppedEvents, date) {
  var dateStamp = format(date, "dd.MM.yyyy");

  for (var i = grouppedEvents.length - 1; i >= 0; i--) {
    var group = grouppedEvents[i];

    if (group.dateStamp === dateStamp) {
      return group.events;
    }
  }

  var newGroup = {
    date: date,
    dateStamp: dateStamp,
    events: []
  };
  grouppedEvents.push(newGroup);
  return newGroup.events;
}

function transformRawEvents(rawEvents, alarms) {
  var grouppedEvents = [];

  if (!rawEvents || rawEvents.length === 0) {
    return grouppedEvents;
  }

  var finishedQueue = {};
  var restarted = false;
  rawEvents = [].concat(_toConsumableArray(rawEvents), [{
    alarms: [],
    eventAt: rawEvents[rawEvents.length - 1].eventAt
  }]);

  for (var i = 0; i < rawEvents.length - 1; i++) {
    var first = rawEvents[i];
    var second = rawEvents[i + 1];
    var isInit = first.init;
    var eventAt = new Date(+first.eventAt);
    var events = getEventsGroup(grouppedEvents, eventAt);
    var startedAlarms = isInit ? first.alarms : difference(first.alarms, second.alarms);
    var finishedAlarms = isInit ? [] : difference(second.alarms, first.alarms);

    var _iterator = _createForOfIteratorHelper(startedAlarms),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var alarm = _step.value;
        var event = {
          id: "".concat(first.streamId, "-").concat(alarm),
          init: false,
          alarmId: alarm,
          eventAt: eventAt,
          finishedAt: finishedQueue[alarm],
          active: !finishedQueue[alarm] && !restarted && alarms.includes(alarm)
        };
        delete finishedQueue[alarm];
        events.push(event);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var _iterator2 = _createForOfIteratorHelper(finishedAlarms),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _alarm = _step2.value;
        finishedQueue[_alarm] = eventAt;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    if (isInit) {
      events.push({
        id: "".concat(first.streamId, "-init"),
        init: true,
        eventAt: eventAt
      });
      restarted = true;
    }
  }

  outter: for (var _i = grouppedEvents.length - 1; _i >= 0; _i--) {
    var _events = grouppedEvents[_i].events;

    for (var j = _events.length - 1; j >= 0; j--) {
      if (_events[j].init) {
        _events.pop();
      } else {
        break outter;
      }
    }
  }

  return grouppedEvents.filter(function (g) {
    return g.events.length > 0;
  });
}

function transformJournal(records, alarms) {
  var grouppedEvents = [];

  if (!records || records.length === 0) {
    return grouppedEvents;
  }

  var finishedQueue = {};
  var usedAlarms = {};

  for (var i = 0; i < records.length; i++) {
    var event = records[i];
    var createdAt = new Date(+event.createdAt);
    var dateGroup = getEventsGroup(grouppedEvents, createdAt);

    if (event.kind === "START") {
      dateGroup.push({
        id: "".concat(event.streamId, "-").concat(event.alarm),
        init: false,
        alarmId: event.alarm,
        eventAt: createdAt,
        finishedAt: finishedQueue[event.alarm],
        active: !finishedQueue[event.alarm] && alarms.includes(event.alarm) && !usedAlarms[event.alarm]
      });
      delete finishedQueue[event.alarm];
      usedAlarms[event.alarm] = true;
    }

    if (event.kind === "FINISH") {
      finishedQueue[event.alarm] = createdAt;
    }
  }

  return grouppedEvents.filter(function (g) {
    return g.events.length > 0;
  }).sort(function (a, b) {
    if (a.date > b.date) {
      return -1;
    }

    if (a.date < b.date) {
      return 1;
    }

    return 0;
  });
}